module.exports = __webpack_public_path__ + "img/weeare.19b1ee5f.png";